<template>
 <div class="bubble-container">
     <h4 class="bubble-title">Pour rester attractifs, les sites copient les placements "à la mode"</h4>
     <div class="slider_button_bubble">
         <button class="prev_img_text" @click="decreaseIndexByButton"></button>
         <button class="next_img_text" @click="increaseIndexByButton"></button>
     </div>
     <div class="bubble_sub_container">
        <div class="bubble_bloc_text">
            <h4>En {{this.year}}</h4>
            <p>{{this.currentText}}</p>

        </div>
        <highcharts class="bubble" ref="myBubble" :options="chartOptions"></highcharts>
    </div>



     <div class="dot_block_bubble">
         <button @click="changeIndex(0)" class="dot" id="dot_0"></button>
         <button @click="changeIndex(1)" class="dot" id="dot_1"></button>
         <button @click="changeIndex(2)" class="dot" id="dot_2"></button>
         <button @click="changeIndex(3)" class="dot" id="dot_3"></button>
         <button @click="changeIndex(4)" class="dot" id="dot_4"></button>
         <button @click="changeIndex(5)" class="dot" id="dot_5"></button>
         <button @click="changeIndex(6)" class="dot" id="dot_6"></button>
         <button @click="changeIndex(7)" class="dot" id="dot_7"></button>
         <button @click="changeIndex(8)" class="dot" id="dot_8"></button>
         <button @click="changeIndex(9)" class="dot" id="dot_9"></button>
         <button @click="changeIndex(10)" class="dot" id="dot_10"></button>
         <button @click="changeIndex(11)" class="dot" id="dot_11"></button>
         <button @click="changeIndex(12)" class="dot" id="dot_12"></button>

     </div>


 </div>
</template>

<script>
    export default {
        data: function () {
            return {
                year: 2010,
                index: 0,
                currentText: 'Juste après la crise de 2008, les épargnants craignent un écroulement des banques. Ils cherchent des placements alternatifs. Les premières escroqueries en ligne apparaissent.',
                text: ["Juste après la crise de 2008, les épargnants craignent un écroulement des banques. Ils cherchent des placements alternatifs. Les premières escroqueries en ligne apparaissent.",
                    "Le marché du forex s'ouvre aux particuliers grâce à de nombreux nouveaux acteurs financiers. Profitant du flou de la législation et du foisonnement des offres, les escrocs lancent les premiers faux sites de placement.",
                    "Consistant à parier sur l'avenir, les options binaires font fureur chez les épargnants, de nombreux faux sites proposent ce genre de produits financiers.",
                    "Grâce à la multiplication des publicités en ligne et, plus particulièrement, sur les réseaux sociaux, le business des fausses options binaires connaît un bon spectaculaire.",
                    "Voyant le phénomène des arnaques au forex et aux options binaires prendre de l'ampleur, les autorités tirent le signal d'alarme et lancent des campagnes de pub pour dissuader les épargnants d'investir sur ces plateformes.",
                    "De nouvelles escroqueries font leur apparition avec notamment la folie - éphémère - des terres rares : des métaux à usage industriel, servant notamment à fabriquer des téléphones portables, dont le cours a fortement augmenté au début des années 2010.",
                    "Le vrai cours du diamant progresse fortement de 2012 à 2015, les escrocs s'en emparent et font un ravage avec ce faux placement.",
                    "Les arnaques se diversifient et l'on voit apparaître les premiers \"supermarchés de l'arnaque\" qui disposent d'une gamme très large de faux produits financiers : crowdfunding, bitcoins, grand crus...",
                    "Passant de 1000 $ le 1er janvier à quasiment 20 000 $ en décembre, le bitcoin affole les épargnants, notamment les plus jeunes. Les escrocs lancent des sites de fausses cryptomonnaies à tours de bras.",
                    "Le soufflet du bitcoin retombé, les escrocs se diverfisent vers des produits plus concrets comme les parkings ou les cheptels.",
                    "Pour crédibiliser leur offre, les fraudeurs n'hésitent plus à usurper l'identité de l'Autorité des marchés financiers ou de sociétés de gestion ayant pignon sur rue.",
                    "La pandémie du covid-19 et le retour en grâce du bitcoin favorisent l'émergence de nouvelles arnaques en ligne. Les fraudeurs inventent, entre autres, le faux placement dans des sociétés gérant des containeurs maritimes.",
                    "Les autorités constatent une montée en puissance des usurpations d'identités. Les escrocs vous font croire que vous dialoguez avec un acteur financier existant avant de vous faire investir, entre autres, dans de faux livrets d'épargne."
                ],
                chartOptions: {
                    chart: {
                        type: 'bubble',
                        plotBorderWidth: 0,
                        height: '60%',
                        width: null,
                        zoomType: 'xy',
                        backgroundColor:'#E0EEF5'

                    },
                    legend: {
                        enabled: false
                    },
                    title: {
                        text: null

                    },
                    xAxis: {
                        floor:-3,
                        min:-3,
                        max:20,
                        visible: false,
                    },
                    yAxis: {
                        min:-3,
                        max:18,
                        visible: false,
                    },
                    tooltip: {
                        useHTML: false,
                        headerFormat: '<table>',
                        pointFormat: '<tr><th colspan="2"><p>{point.z} sites de faux {point.name} détectés</p></th></tr>',
                        footerFormat: '</table>',
                        followPointer: true
                    },
                    plotOptions: {
                        bubble:{
                            minSize:20,
                            maxSize:150,
                            layoutAlgorithm: {
                                splitSeries: false,
                                gravitationalConstant: 10
                            },
                        },
                        series: {
                            dataLabels: {
                                enabled: true,
                                format: '{point.name}'
                            }
                        }
                    },

                    series: [{
                        data: [],
                        animation: {
                            /*defer: 2,*/
                            duration: 4000,
                            // Uses simple function
                        }
                    }]
                    ,
                    responsive:{
                        rules: [{
                            condition:{
                                maxWidth:500
                            },
                            chartOptions: {
                                xAxis: {
                                    floor:-10,
                                    min:-2,
                                    max:20,
                                    visible: false,
                                },
                                yAxis: {
                                    min:-20,
                                    max:25,
                                    visible: false,
                                },
                                tooltip: {
                                    useHTML: true,
                                    headerFormat: '<table>',
                                    pointFormat: '<tr><th colspan="2"><p>{point.z} sites de faux {point.name} détectés</p></th></tr>',
                                    footerFormat: '</table>',
                                    followPointer: true
                                },
                                plotOptions: {
                                    bubble:{
                                        minSize:10,
                                        maxSize:80,
                                        layoutAlgorithm: {
                                            splitSeries: false,
                                            gravitationalConstant: 10
                                        },
                                    },
                                    series: {
                                        dataLabels: {
                                            enabled: true,
                                            format: '{point.name}'
                                        }
                                    }
                                },

                                series: [{
                                    data: [],
                                    animation: {
                                        defer: 2,
                                        duration: 4000,
                                        // Uses simple function
                                    }
                                }]

                        }
                 }],


                }

                /*###### FIN DATA #########*/
            }
            }
        }, mounted() {
            const _self = this;
            setTimeout(function () {
               _self.$refs['myBubble'].chart.series[0].setData(_self.$store.getters.cat_2010_init)
               _self.changeActiveClass(0)

            }, 4000)



        },watch:{
               index: function(){
                  const _self = this;
                  switch (_self.index) {
                          case 0:
                              this.year = 2010
                              this.currentText = this.text[0]
                              this.$refs['myBubble'].chart.series[0].setData(this.$store.getters.cat_2010)
                              this.changeActiveClass(0)
                              break;

                          case 1:
                              this.year = 2011
                              this.currentText = this.text[1]
                              this.$refs['myBubble'].chart.series[0].setData(this.$store.getters.cat_2011)
                              this.changeActiveClass(1)
                              break;

                          case 2:
                              this.year = 2012
                              this.currentText = this.text[2]
                              this.$refs['myBubble'].chart.series[0].setData(this.$store.getters.cat_2012)
                              this.changeActiveClass(2)
                              break;

                          case 3:
                              this.year = 2013
                              this.currentText = this.text[3]
                              this.$refs['myBubble'].chart.series[0].setData(this.$store.getters.cat_2013)
                              this.changeActiveClass(3)
                              break;

                          case 4:
                              this.year = 2014
                              this.currentText = this.text[4]
                              this.$refs['myBubble'].chart.series[0].setData(this.$store.getters.cat_2014)
                              this.changeActiveClass(4)
                              break;

                          case 5:
                              this.year = 2015
                              this.currentText = this.text[5]
                              this.$refs['myBubble'].chart.series[0].setData(this.$store.getters.cat_2015)
                              this.changeActiveClass(5)
                              break;

                          case 6:
                              this.year = 2016
                              this.currentText = this.text[6]
                              this.$refs['myBubble'].chart.series[0].setData(this.$store.getters.cat_2016)
                              this.changeActiveClass(6)
                              break;

                          case 7:
                              this.year = 2017
                              this.currentText = this.text[7]
                              this.$refs['myBubble'].chart.series[0].setData(this.$store.getters.cat_2017)
                              this.changeActiveClass(7)
                              break;

                          case 8:
                              this.year = 2018
                              this.currentText = this.text[8]
                              this.$refs['myBubble'].chart.series[0].setData(this.$store.getters.cat_2018)
                              this.changeActiveClass(8)
                              break;

                          case 9:
                              this.year = 2019
                              this.currentText = this.text[9]
                              this.$refs['myBubble'].chart.series[0].setData(this.$store.getters.cat_2019)
                              this.changeActiveClass(9)
                              break;

                          case 10:
                              this.year = 2020
                              this.currentText = this.text[10]
                              this.$refs['myBubble'].chart.series[0].setData(this.$store.getters.cat_2020)
                              this.changeActiveClass(10)
                              break;


                          case 11:
                              this.year = 2021
                              this.currentText = this.text[11]
                              this.$refs['myBubble'].chart.series[0].setData(this.$store.getters.cat_2021)
                              this.changeActiveClass(11)
                              break;

                          case 12:
                              this.year = 2022
                              this.currentText = this.text[12]
                              this.$refs['myBubble'].chart.series[0].setData(this.$store.getters.cat_2022)
                              this.changeActiveClass(12)
                              break;

                     }

                }
        },
        methods:{

               increaseIndexByButton(){
                   if (this.index!=12){
                       this.index+=1;
                   }
                   else if(this.index==12){
                       this.index=0
                   }
               },
               decreaseIndexByButton(){
                   if (this.index!=0){
                       this.index-=1;
                   }
                   else if(this.index==0){
                       this.index=12
                   }

                         },


               changeIndex(indexNumber) {
                   var myDot_0 = document.getElementById('dot_0')
                   var myDot_1 = document.getElementById('dot_1')
                   var myDot_2 = document.getElementById('dot_2')
                   var myDot_3 = document.getElementById('dot_3')
                   var myDot_4 = document.getElementById('dot_4')
                   var myDot_5 = document.getElementById('dot_5')
                   var myDot_6 = document.getElementById('dot_6')
                   var myDot_7 = document.getElementById('dot_7')
                   var myDot_8 = document.getElementById('dot_8')
                   var myDot_9 = document.getElementById('dot_9')
                   var myDot_10 = document.getElementById('dot_10')
                   var myDot_11 = document.getElementById('dot_11')
                   var myDot_12 = document.getElementById('dot_12')

                   myDot_0.classList.remove('dot-active')
                   myDot_1.classList.remove('dot-active')
                   myDot_2.classList.remove('dot-active')
                   myDot_3.classList.remove('dot-active')
                   myDot_4.classList.remove('dot-active')
                   myDot_5.classList.remove('dot-active')
                   myDot_6.classList.remove('dot-active')
                   myDot_7.classList.remove('dot-active')
                   myDot_8.classList.remove('dot-active')
                   myDot_9.classList.remove('dot-active')
                   myDot_10.classList.remove('dot-active')
                   myDot_11.classList.remove('dot-active')
                   myDot_12.classList.remove('dot-active')


                   switch (indexNumber) {
                       case 0:
                           this.index = 0;

                           myDot_0.classList.add('dot-active')
                           break;

                       case 1:
                           this.index = 1;
                           myDot_1.classList.add('dot-active')
                           break;

                       case 2:
                           this.index = 2;
                           myDot_2.classList.add('dot-active')
                           break;

                       case 3:
                           this.index = 3;
                           myDot_3.classList.add('dot-active')
                           break;

                       case 4:
                           this.index = 4;
                           myDot_4.classList.add('dot-active')
                           break;

                       case 5:
                           this.index = 5;
                           myDot_5.classList.add('dot-active')
                           break;

                       case 6:
                           this.index = 6;
                           myDot_6.classList.add('dot-active')
                           break;

                       case 7:
                           this.index = 7;
                           myDot_7.classList.add('dot-active')
                           break;

                       case 8:
                           this.index = 8;
                           myDot_8.classList.add('dot-active')
                           break;

                       case 9:
                           this.index = 9;
                           myDot_9.classList.add('dot-active')
                           break;

                       case 10:
                           this.index = 10;
                           myDot_10.classList.add('dot-active')
                           break;

                       case 11:
                           this.index = 11;
                           myDot_11.classList.add('dot-active')
                           break;

                       case 12:
                           this.index = 12;
                           myDot_12.classList.add('dot-active')
                           break;

                   }

               },
                   changeActiveClass(indexNumber){
                       var myDot_0 = document.getElementById('dot_0')
                       var myDot_1 = document.getElementById('dot_1')
                       var myDot_2 = document.getElementById('dot_2')
                       var myDot_3= document.getElementById('dot_3')
                       var myDot_4= document.getElementById('dot_4')
                       var myDot_5 = document.getElementById('dot_5')
                       var myDot_6 = document.getElementById('dot_6')
                       var myDot_7 = document.getElementById('dot_7')
                       var myDot_8= document.getElementById('dot_8')
                       var myDot_9 = document.getElementById('dot_9')
                       var myDot_10 = document.getElementById('dot_10')
                       var myDot_11 = document.getElementById('dot_11')
                       var myDot_12 = document.getElementById('dot_12')

                       myDot_0.classList.remove('dot-active')
                       myDot_1.classList.remove('dot-active')
                       myDot_2.classList.remove('dot-active')
                       myDot_3.classList.remove('dot-active')
                       myDot_4.classList.remove('dot-active')
                       myDot_5.classList.remove('dot-active')
                       myDot_6.classList.remove('dot-active')
                       myDot_7.classList.remove('dot-active')
                       myDot_8.classList.remove('dot-active')
                       myDot_9.classList.remove('dot-active')
                       myDot_10.classList.remove('dot-active')
                       myDot_11.classList.remove('dot-active')
                       myDot_12.classList.remove('dot-active')


                       switch (indexNumber) {
                           case 0:
                               myDot_0.classList.add('dot-active')
                               break;

                           case 1:
                               myDot_1.classList.add('dot-active')
                               break;

                           case 2:
                               myDot_2.classList.add('dot-active')
                               break;

                           case 3:
                               myDot_3.classList.add('dot-active')
                               break;

                           case 4:
                               myDot_4.classList.add('dot-active')
                               break;

                           case 5:
                               myDot_5.classList.add('dot-active')
                               break;

                           case 6:
                               myDot_6.classList.add('dot-active')
                               break;

                           case 7:
                               myDot_7.classList.add('dot-active')
                               break;

                           case 8:
                               myDot_8.classList.add('dot-active')
                               break;

                           case 9:
                               myDot_9.classList.add('dot-active')
                               break;

                           case 10:
                               myDot_10.classList.add('dot-active')
                               break;

                           case 11:
                               myDot_11.classList.add('dot-active')
                               break;

                           case 12:
                               myDot_12.classList.add('dot-active')
                               break;
                       }
                   }
               }

    }
</script>

<style>

    /*-------------- BUBLE -----------*/

.bubble-container{
        position:relative;
        top:15vh;
        height:65vh;
        display:flex;
        flex-direction:column;
        justify-content: center;
        align-items: center;
        margin-bottom:15vh;

    }


.bubble_sub_container{
        top:7vh;
        height:70vh;
        display:flex;
        justify-content:space-between;
        position:relative;
        width:70vw;
    }

.bubble-title{
        text-align:center;
        width:80%;
        margin-bottom:0;
        }


.slider_button_bubble{
        position:relative;
        top:50%;

        width: 90vw;
        display:flex;
        justify-content: space-between;
    }


    @media screen and (max-width: 430px) {
                .bubble-container {
            position: relative;
            height: 80vh;
            top: 10vh;
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            margin-top:3vh;
            margin-bottom:20vh;
        }


        .bubble-title {
            text-align: center;
            width: 80%;
            top: 20%;

        }
        .slider_button_bubble{
            position:relative;
            top:79vh;
            width: 90vw;
            display:flex;
            justify-content: space-between;
        }

    }


    @media screen and (max-width: 1000px) and (min-width:431px) {
        .bubble-container {
            position: relative;
            height:70vh;
            top: 10vh;
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            margin-top:10vh;
            margin-bottom:15vh;
        }


        .bubble-title {
            text-align: center;
            width: 80%;
            top: 20%;

        }
        .slider_button_bubble{
            position:relative;
            top:79vh;
            width: 90vw;
            display:flex;
            justify-content: space-between;
        }



    }






.bubble{
    display:flex;
    justify-content:center;
    width:80vw;
    background-color:#E0EEF5;
    /*background-color: #FAFCFF;*/

}

.bubble_bloc_text{
    width:20vw

}


div.bubble_sub_container .highcharts-background{
    width:100%;
    height:80%;

}
div.bubble_sub_container .highcharts-root{
    height:100%;
}


.dot{
     height: 15px;
     width: 15px;
     border:none;
     border-radius: 50%;
     display: inline-block;
     background-color:#cddbeb;
     cursor:pointer;
    }

.dot_block_bubble{
    width:20vw;
    height:5vh;
    transform: translateX(5vw);
    position:relative;
    display:flex;
    justify-content:space-between;
    align-items: center;

}
.dot-active{
    background-color:#505ead;
}


@media screen and (max-width: 430px) {

    .bubble_sub_container {
        top: 0px;
        height: 60vh;
        display: flex;
        flex-direction: column-reverse;
        justify-content: center;
        align-items: center;
        position: relative;
        width: 100vw;
    }


      .bubble {
        position: relative;
        width: 100vw;
        height: 50vh;
    }

    .bubble_bloc_text {
        width: 80vw;
        height: 20vh;
        display: flex;
        flex-direction: column;
        align-items: center;
    }


    div.bubble_sub_container .highcharts-background {
        width: 100vw;
        height: 60vh;

    }

    div.bubble_sub_container .highcharts-root {
        height: 40vh;
    }



    .dot {
        height:15px;
        width:15px;
        padding:0;
    }

    .dot_block_bubble {
        width: 50vw;
        height: auto;
        top:10vh;
        transform: translateX(0vw);
        position: relative;
        display: flex;
        justify-content: space-between;
        align-items: center;

    }

}

    @media screen and (max-width: 1000px) and (min-width:431px) {
        .bubble_sub_container {
            top: 0px;
            height: 60vh;
            display: flex;
            flex-direction: column-reverse;
            justify-content: center;
            align-items: center;
            position: relative;
            width: 100vw;
        }


        .bubble {
            position: relative;
            width: 100vw;
            height: 50vh;
        }

        .bubble_bloc_text {
            width: 80vw;
            height: 20vh;
            display: flex;
            flex-direction: column;
            align-items: center;
        }


        div.bubble_sub_container .highcharts-background {
            width: 100vw;
            height: 60vh;

        }

        div.bubble_sub_container .highcharts-root {
            height: 40vh;
        }



        .dot {
            height:15px;
            width: 15px;
            padding:0;
        }


        .dot_block_bubble {
            width: 50vw;
            height: 10vh;
            top:-5vh;
            transform: translateX(0vw);
            position: relative;
            display: flex;
            justify-content: space-between;
            align-items: center;
        }

    }
</style>